export default "__VITE_ASSET__CGDI_wEB__"